import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClipboardCopyModule } from 'studio-components/clipboard-copy/clipboard-copy.module';
import { ButtonLegacyModule } from 'studio-components/button-legacy/button-legacy.module';
import { CopiableTextComponent } from './components/copiable-text/copiable-text.component';
import { IconModule } from 'studio-components/icon/icon.module';
import { FormModule } from 'studio-components/form/form.module';

@NgModule({
  declarations: [CopiableTextComponent],
  imports: [CommonModule, ButtonLegacyModule, IconModule, ClipboardCopyModule, FormModule],
  exports: [CopiableTextComponent],
})
export class CopiableTextModule {}
